import { ChevronsUpDown } from "lucide-react"

import { Button } from "@/components/ui/button.tsx"
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu.tsx"
import { ScrollArea } from "@/components/ui/scroll-area.tsx"

export default function MultiFilter<T>({
  label,
  options,
  selected,
  setSelected,
  displayFunc,
}: {
  label: string
  options: T[]
  selected: T[] | undefined
  setSelected: (val: T, selected: boolean) => void
  displayFunc: (v: T) => React.ReactNode
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="w-full flex justify-between">
          {label} <ChevronsUpDown className="opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="max-h-[400px]">
        <ScrollArea className="h-full">
          {options.map((opt, i) => (
            <DropdownMenuCheckboxItem
              checked={selected?.findIndex((s) => s == opt) != -1 || false}
              onCheckedChange={(checked) => setSelected(opt, checked)}
              key={i}
            >
              {displayFunc(opt)}
            </DropdownMenuCheckboxItem>
          ))}
        </ScrollArea>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
